export default __webpack_public_path__ + "static/media/world.2c48efcf.png";